export default "__VITE_ASSET__e441b061__"